
<template>
<tr class="smsc-table__row">
  <slot />
</tr>
</template>

<script>
export default {
  name: 'smsc-tr'
}
</script>